import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TextField } from '@/components/functional/Form/TextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { validateAddMemberCompanyName } from '@/utils/validate/resources/rfp/professional/rfpProOfferMember';
/**
 * 案件メンバー追加 企業名
 */
export const RfpProMemberAddCompanyNameField = (props) => {
    const { className = '', name } = props;
    return (_jsx(FieldLabel, Object.assign({ className: className, isRequired: true, labelText: '企業名' }, { children: _jsx(TextField, { name: name, type: 'text', validate: validateAddMemberCompanyName }) })));
};
